import { loadSdk } from "./loadSdk";

export const showBanner = store => {
  loadSdk(store);
};
